import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { Breakpoints, MQ } from 'style/styled-components/cssMediaQueries';
import { fontBold, fontExtraBold, fontNormal } from 'style/styled-components/cssGlobalVariables';
import { visuallyHidden } from 'style/styled-components/cssHeadings';

export const PageWrapper = styled.div`
    background-color: var(--color-dark-background);
    margin: 0 auto;
    padding: 88px 16px 0 16px;
    max-width: 640px;

    ${MQ(Breakpoints.s)} {
        padding: 88px 0 0 0;
    }

    ${MQ(Breakpoints.m)} {
        padding: 128px 0 0 0;
    }
`;

export const Title = styled.h1`
    color: var(--color-dark-body);
    font-size: 32px;
    line-height: 40px;
    font-family: ${fontExtraBold};
    text-align: center;
    padding-bottom: 24px;

    @media not all and (min-width: ${Breakpoints.m}) {
        ${visuallyHidden}
    }
`;

export const HintText = styled.p`
    color: var(--color-dark-body-70);
    text-align: left;
    font-size: 16px;
    line-height: 24px;
    padding-bottom: 26px;

    ${MQ(Breakpoints.m)} {
        text-align: center;
        padding: 0 90px 16px 90px;
    }
`;

const InlineHint = styled(HintText)`
    text-align: left;
    padding: 0;

    ${MQ(Breakpoints.m)} {
        text-align: left;
        padding: 0;
    }
`;

export const SelectHint = styled(InlineHint)`
    font-family: ${fontNormal};
    text-align: center;
`;

export const DeviceHint = styled(InlineHint)`
    font-family: ${fontBold};
    padding-bottom: 8px;
    color: ${(props) => props.theme.brandedConfig.white_color};
`;

export const DeviceList = styled.div`
    padding-top: 16px;

    ${MQ(Breakpoints.s)} {
        padding-top: 24px;
    }
`;

export const SignOutButton = styled.a`
    flex-grow: 0;
    font-size: 16px;
    line-height: 24px;
    color: ${(props) => props.theme.brandedConfig.primary};
    cursor: pointer;
`;

export const Icon = styled.div`
    .SVGInline {
        width: 24px;
        height: 24px;
    }
`;
